import { X, Sparkles } from 'lucide-react';
import { useState } from 'react';
import { useSignupUrl } from '@/hooks/useSignupUrl';
import { useTranslation } from '@/i18n/i18n';

export const AnnouncementBar = () => {
  const [isVisible, setIsVisible] = useState(true);
  const signupUrl = useSignupUrl({ source: 'announcement_bar' });
  const { t } = useTranslation();

  return isVisible ? (
    <div className="bg-gradient-to-r from-primary via-primary to-gold text-primary-foreground px-4 py-1.5 sm:py-2 relative animate-fade-in">
      <div className="max-w-7xl mx-auto flex items-center justify-center gap-3 pr-12">
        <div className="flex min-h-10 items-center gap-2 text-xs font-semibold sm:text-sm">
          <Sparkles className="size-4 hidden sm:inline" />
          <span className="text-center">
            <span className="hidden sm:inline">
              {t('announcement.text')} <span className="font-bold">{t('announcement.free')}</span>
            </span>
            <span className="sm:hidden">{t('announcement.free')}</span>
          </span>
          <a
            href={signupUrl}
            className="inline-flex min-h-11 items-center underline hover:no-underline ml-1 font-bold text-center"
          >
            {t('announcement.cta')}
          </a>
        </div>

        <button
          onClick={() => setIsVisible(false)}
          className="absolute right-1 top-1/2 flex size-11 -translate-y-1/2 items-center justify-center rounded-lg hover:bg-primary-foreground/10 transition-colors sm:right-2"
          aria-label={t('announcement.close')}
        >
          <X className="size-4" />
        </button>
      </div>
    </div>
  ) : null;
};
